<template>
  <main>
    <news-filter :clubNews="clubNews" @filtered="updateFilteredNews"></news-filter>
    <section class="section">
      <div class="container">
        <div class="section__block">
          <h1 class="text-center mb-5 headline--underlined">Aktuelles</h1>
        </div>
        <div class="section__block">
          <div class="row justify-content-center">
            <div v-for="newsItem in filteredNews" :key="newsItem.id" class="col-12 col-md-6 col-lg-4">
              <div
                  class="card"

              >
                <figure v-if="imageSrc(newsItem)">
                  <img class="card-img-top" :src="imageSrc(newsItem)" alt="Card image"/>
                </figure>
                <span class="badge rounded-pill" :style="{ backgroundColor: 'var(' + getClubById(newsItem.clubId)?.backgroundColor + ')' }">{{getClubById(newsItem.clubId)?.name}}</span>
                <div class="card-body">
                  <h3 class="card-title">{{ newsItem.title }}</h3>
                  <p class="card-text">{{ newsItem.text }}</p>
                  <router-link :to="{ name: 'focusNews', params: {id: newsItem.id}}"
                               class="card__link link link--internal">weiterlesen
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>

import {onMounted, ref, computed} from "vue";
import axios from 'axios';
import NewsFilter from "./NewsFilter.vue";

export default {
  components: {NewsFilter},
  setup() {

    const clubNews = ref([]);
    const filteredNews = ref(clubNews.value);

    // Methode zum Aktualisieren der gefilterten Nachrichten
    const updateFilteredNews = (filtered) => {
      filteredNews.value = filtered;
    };

    const fetchData = async () => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/news/news-not-in-clubid/1');
        clubNews.value = response.data;
        filteredNews.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }

    const clubs = ref([]);

    const fetchClubs = async() => {
      try {
        const response = await axios.get('http://localhost:8082/gemeinde/clubs');
        clubs.value = response.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getClubById = (clubId) => {
      return clubs.value.find(club => club.id === clubId);
    };


    onMounted(() => {
      fetchData();
      fetchClubs();
    })

    // Computed Property für das Bild
    const imageSrc = computed(() => (newsItem) => {
      return newsItem.imageName
          ? 'http://localhost:8082/' + newsItem.imageName.split('/').pop()
          : new URL('@/assets/images/news-placeholder.png', import.meta.url).href;
    });

    return {
      clubNews,
      imageSrc,
      filteredNews,
      updateFilteredNews,
      getClubById
    };
  }
}
</script>

<style></style>
